-<template>
<div v-if="arrayOfStoriesID.length > 0"  height="100%" v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
      up: () => swipe('Up'),
      down: () => swipe('Down')
    }">


    <singleStoryView :singleStoryID="parseInt(getSelectedSingleStoryID)"/>

</div>
</template>

<script>


import singleStoryView from "@/components/singleStoryView.vue";
import {
  Touch
} from "vuetify/lib/directives"

export default {
  name:'carouselForSingleStoryView',
//  mixins: [dialogMixin],
   data () {
      return {
        apiUrl: process.env.VUE_APP_ROOT_API,
        //all the information of the selected story

        apiStrapi: process.env.VUE_APP_ROOT_STRAPI,
        arrayOfStoriesID:[],


      }
    },

    beforeRouteEnter(to, from, next){
      next (vm => {
      //this.orderedAllStories = this.allStories.slice(this.counter).concat(this.allStories.slice(0,this.counter))
      vm.arrayOfStoriesID = vm.getCurrentListOfStoriesCarousel.map(singleStoryObject => singleStoryObject.id)
      return (to, from)
      }
      )
    },
    methods: {
      swipe(value)
      {
        this.arrayOfStoriesID = this.arrayOfStoriesID.slice(1).concat(this.arrayOfStoriesID.slice(0,1))
        if (value=='Right'){
                  this.$store.dispatch('setSelectedSingleStoryID', this.arrayOfStoriesID[this.arrayOfStoriesID.indexOf(this.getSelectedSingleStoryID.toString())+1])
                  this.$router.push({
                'name': 'carouselForSingleStoryView',query: { idStory: this.arrayOfStoriesID[this.arrayOfStoriesID.indexOf(this.getSelectedSingleStoryID.toString())+1] }
              })
        }

        if (value=='Left'){
          this.$store.dispatch('setSelectedSingleStoryID', this.arrayOfStoriesID[this.arrayOfStoriesID.indexOf(this.getSelectedSingleStoryID.toString())-1])
        this.$router.push({
                'name': 'carouselForSingleStoryView',query: { idStory: this.arrayOfStoriesID[this.arrayOfStoriesID.indexOf(this.getSelectedSingleStoryID.toString())-1] }
              })
        }
      }
    },
    props: {
    },
    directives: {
      Touch
    },
    components:{
      singleStoryView
    },
      mounted() {

      },
  computed: {
    getCurrentListOfStoriesCarousel: {
      get: function () {
        return this.$store.getters.getCurrentListOfStoriesCarousel;
      }
    },
    getSelectedSingleStoryID: {
      get: function () {
        return parseInt(this.$store.getters.getSelectedSingleStoryID)
      }
    },
    getUser: {
      get: function () {
        return this.$store.getters.getUser;
      }
    },
    accessToken: {
      get: function () {
        return this.$store.getters.getAccessToken;
      }
    }
    },

}
</script>
<style>
.btnConnectedness{
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.titleStory{
  font-weight: bolder;
  font-size:1.2rem
}

.contentpreview > img{
  max-width: 100%;
}
table th {
    background-color: #e0e0e0;
    color: #000;
    text-align: left;
    vertical-align: bottom;
}
td{
  text-align: center;
  }
table td, table th {
    padding: .5em 1em;
}
table th {
    color: #000;
    text-align: left;
}


</style>